import "core-js/es6/array";
import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/fn/object/values";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { App } from './components';
import stores from './stores';
import './css/styles.scss';

ReactDOM.render(
  <Provider {...stores}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js